import gql from 'graphql-tag';
import {processResponse} from "./helper";

export const getShippingPreSignedUrl = gql `
  query getShippingPreSignedUrl($s3Uri: String!) {
    getShippingPreSignedUrl(s3Uri: $s3Uri) {
      s3PreSignedUrl  
    }
  }
`;

export function getShipmentPreSignedUrl(this:any, s3Uri: String) {
    return processResponse(this.query({
        query: getShippingPreSignedUrl,
        variables: { s3Uri },
    }), "getShippingPreSignedUrl");
}